// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3KRPG","overflowing":"ReadFullNote_overflowing__267bc"};